'use client';

var __jsx = React.createElement;
import React, { useEffect, useState } from 'react';
import { MuscleButton } from '../../components/buttons';
import { useTranslations } from 'next-intl';
import { useErrorPage } from '@lib/context/shared/errors-context';
import errorImagesStoryblokService from '@lib/storyblok/services/financial-entity-services/error-images-service';
import PageContainer from "@modules/layout/components/shared/container";
import APP_CONFIGURATION from '@lib/app.config';
import { cn } from '@lib/cn';
const ErrorScreen = _ref => {
  let {
    code,
    addButton = true,
    title: propTitle,
    subtitle,
    message: propMessage,
    buttonText: propButtonText,
    onClickButton: propOnClickButton,
    storyblokImageKey
  } = _ref;
  const imageKey = storyblokImageKey !== null && storyblokImageKey !== void 0 ? storyblokImageKey : code;
  const {
    titleStyle = "text-base font-thin text-black text-center",
    subtitleStyle = "text-2xl font-bold text-primary-main text-center",
    messageStyle = "text-base font-thin text-black text-center"
  } = APP_CONFIGURATION.config.errorPageConfig;
  const t = useTranslations();
  const {
    closeErrorPage
  } = useErrorPage();
  const {
    0: image,
    1: setImage
  } = useState("");
  const title = propTitle !== null && propTitle !== void 0 ? propTitle : t("Shared.Errors.PAGE_ERRORS.".concat(code, ".TITLE"));
  const message = propMessage !== null && propMessage !== void 0 ? propMessage : t("Shared.Errors.PAGE_ERRORS.".concat(code, ".MESSAGE"));
  const buttonText = propButtonText !== null && propButtonText !== void 0 ? propButtonText : t("Shared.Errors.RETURN_TO_HOME");
  const onClickButton = propOnClickButton !== null && propOnClickButton !== void 0 ? propOnClickButton : closeErrorPage;
  useEffect(() => {
    const fetchImage = async () => {
      const image = await errorImagesStoryblokService.getErrorImage(imageKey);
      setImage(image);
    };
    fetchImage();
  }, []);
  const aboveImageNode = subtitle ? __jsx("p", {
    className: cn(titleStyle, "max-w-[232px] md:max-w-fit")
  }, title) : null;
  const belowImageNode = __jsx("p", {
    className: cn(subtitle ? subtitleStyle : titleStyle, "max-w-[186px] md:max-w-fit")
  }, subtitle !== null && subtitle !== void 0 ? subtitle : title);
  return __jsx(PageContainer, null, __jsx("div", {
    className: "pt-8 md:p-16 flex flex-col items-center gap-2"
  }, aboveImageNode, image ? __jsx("img", {
    src: image,
    alt: title,
    className: "w-full max-h-[279px] md:max-h-[320px] max-w-[373px] md:max-w-[400px]"
  }) : __jsx("div", {
    className: "w-full h-[279px] md:h-[320px] max-w-[373px] md:max-w-[400px] flex items-center justify-center"
  }), belowImageNode, __jsx("p", {
    className: cn(messageStyle, "mt-3 max-w-[350px] md:max-w-fit")
  }, message), addButton ? __jsx(MuscleButton, {
    onClick: onClickButton,
    variant: "solidMd"
  }, buttonText) : null));
};
export default ErrorScreen;